import { queryOptions } from "@tanstack/react-query"
import { locationsService } from "@/services/locations.service"

export const LocationQueryOptions = {
  all: queryOptions({
    queryKey: ["locations", "all"],
    queryFn: async () => {
      const response = await locationsService.getAllLocations()

      return response
    },
  }),
  byCode: (code: string) => queryOptions({
    queryKey: ["locations", "byCode", code],
    queryFn: async () => {
      const response = await locationsService.getLocationByCode(code)

      return response
    },
  }),
  byVenue: (venueCode: string) => queryOptions({
    queryKey: ["locations", "byVenue", venueCode],
    queryFn: async () => {
      const response = await locationsService.getLocationsByVenue(venueCode)

      return response
    },
  }),
  byDiscipline: (disciplineCode: string) => queryOptions({
    queryKey: ["locations", "byDiscipline", disciplineCode],
    queryFn: async () => {
      const response = await locationsService.getLocationsByDiscipline(disciplineCode)

      return response
    },
  }),
}
